<template lang="pug">
  .comments-card.-subcomment-
    .comments-card__user
      Avatar(:img="comment.commentatorAvatar", circle, size="xs")
      p.comments-card__user-text
        | {{comment.commentatorName}}
    .comments-card__comment(v-html="commentHTML")
    .comments-card__file-list(
      v-if="comment.commentatorFiles.length"
    )
      File(
        v-for="(file, i) in comment.commentatorFiles"
        :key="file.fileName +'_'+i"
        :file="file"
        :canDelete="false"
      )

    .comments-card__info
      p.comments-card__info-date
        | {{comment.createdAt}}

</template>

<script>
import textToHtmlWithLinks from '@/functions/textToHTMLWithLikns';
import File from '@/components/File/File';

export default {
  components: {
    File
  },
  props: {
    comment: {}
  },
  computed: {
    commentHTML() {
      return textToHtmlWithLinks(this.comment.comment);
    }
  }
};
</script>
